<template>
  <div>
    <Header />
    <span class="back-meal-vue" @click="backHistory">＜ 戻る</span>
    <div class="date">
      <span class="parenthesis" @click="getOneWeek(-1)">＜</span>
      <span class="day">{{ startDate }}〜{{ endDate }}</span>
      <span v-show="isNextWeek" class="parenthesis" @click="getOneWeek(1)">＞</span>
    </div>
    <div class="water-weekly-bar">
      <WaterBarChart
      :chart-data="datacollection"
      :options="options"
      :height="height"
      :width="width"
      v-if="isShowActive" />
    </div>
    <Footer />
  </div>
</template>

<script scoped>
import moment from "moment";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import WaterBarChart from "@/js/WaterBarChart";
export default {
  name: "WaterWeeklyBar",
  components: {
    Header,
    Footer,
    WaterBarChart,
  },
  beforeDestroy() {
    document.body.className = "";
  },
  data() {
    return {
      startDate: "",
      endDate: "",
      Week: 0,
      isNextWeek: false,
      isShowActive: false,
      thisWeekStart: "",
      datacollection: null,
      options: null,
      height: window.innerHeight / 1.5,
      width: window.innerWidth / 1.1,
      oneMonthWaterRecord: [],
      Monday: 0, Tuesday: 1, Wednesday: 2, Thursday: 3, Friday: 4, Saturday: 5, Sunday: 6,
      weekDays: [
        { day: "", water: 0, barColor: "", borderColor: ""},
        { day: "", water: 0, barColor: "", borderColor: "" },
        { day: "", water: 0, barColor: "", borderColor: "" },
        { day: "", water: 0, barColor: "", borderColor: "" },
        { day: "", water: 0, barColor: "", borderColor: "" },
        { day: "", water: 0, barColor: "", borderColor: "" },
        { day: "", water: 0, barColor: "", borderColor: "" },
      ],
    };
  },
  created() {
    this.getThisWeek();
  },
  mounted() {
    document.body.className = "back-color";
    this.thisWeekStart = moment().startOf("isoWeek").format("YYYY-MM-DD");
    this.oneMonthWaterRecord = this.$store.state.oneMonthMealRecord;
    console.log(this.oneMonthWaterRecord)
    this.createWeeklyBarGraph(this.thisWeekStart);
    this.fillData();
    this.isShowActive = true
  },
  methods: {
    getThisWeek() {
      //今週初
      this.startDate = moment().startOf("isoWeek").format("MM-DD");
      //今週末
      this.endDate = moment().endOf("isoWeek").format("MM-DD");
    },
    // 先週または来週を取得する
    getOneWeek(value) {
      this.isNextWeek = true;
      this.Week = this.Week + value;
      this.startDate = moment().add("isoWeek", this.Week).startOf("isoWeek").format("MM-DD");
      this.endDate = moment().add("isoWeek", this.Week).endOf("isoWeek").format("MM-DD");
      this.weekStart = moment().add("isoWeek", this.Week).startOf("isoWeek").format("YYYY-MM-DD");
      if (this.weekStart === this.thisWeekStart) this.isNextWeek = false;
      for(const item in this.weekDays) this.weekDays[item].water = 0
      this.createWeeklyBarGraph(this.weekStart);
      this.fillData();
    },
    createWeeklyBarGraph(weekStart) {
      const len = Object.keys(this.oneMonthWaterRecord).length;
      for (let i = 0; i < 7; i++) {
        const targetWeekDays = moment(weekStart).add(i, "days").format("YYYY-MM-DD");
        this.weekDays[i].day = moment(weekStart).add(i, "days").format("DD");
        for (let n = 0; n < len; n++) {
          if (this.oneMonthWaterRecord[n].date === targetWeekDays) {
            this.weekDays[i].water = this.oneMonthWaterRecord[n].water;
            if (this.weekDays[i].water < 1000) {
              this.weekDays[i].barColor = "#79A6F2"//薄い青
              this.weekDays[i].borderColor = "#79A6F2"
            } else {
              this.weekDays[i].barColor = "#0059F2"//濃い青
              this.weekDays[i].borderColor = "#0059F2"
            }
          }
        }
      }
    },
    fillData() {
      this.datacollection = {
        labels: [
          [this.weekDays[this.Monday].day,    "月"],
          [this.weekDays[this.Tuesday].day,   "火"],
          [this.weekDays[this.Wednesday].day, "水"],
          [this.weekDays[this.Thursday].day,  "木"],
          [this.weekDays[this.Friday].day,    "金"],
          [this.weekDays[this.Saturday].day,  "土"],
          [this.weekDays[this.Sunday].day,    "日"],
         ],
        datasets: [
          {
            // label: '摂取目標1000ml',
            data: [
              this.weekDays[this.Monday].water,
              this.weekDays[this.Tuesday].water,
              this.weekDays[this.Wednesday].water,
              this.weekDays[this.Thursday].water,
              this.weekDays[this.Friday].water,
              this.weekDays[this.Saturday].water,
              this.weekDays[this.Sunday].water
              ],
            backgroundColor: [
              this.weekDays[this.Monday].barColor,
              this.weekDays[this.Tuesday].barColor,
              this.weekDays[this.Wednesday].barColor,
              this.weekDays[this.Thursday].barColor,
              this.weekDays[this.Friday].barColor,
              this.weekDays[this.Saturday].barColor,
              this.weekDays[this.Sunday].barColor
            ],
            borderColor: [
              this.weekDays[this.Monday].borderColor,
              this.weekDays[this.Tuesday].borderColor,
              this.weekDays[this.Wednesday].borderColor,
              this.weekDays[this.Thursday].borderColor,
              this.weekDays[this.Friday].borderColor,
              this.weekDays[this.Saturday].borderColor,
              this.weekDays[this.Sunday].borderColor
            ],
            borderWidth: 1,
            barPercentage: 0.6
          },
        ],
      };
      this.options = {
        responsive: false,// ウィンドウのサイズによってグラフの大きさが変わるか
        maintainAspectRatio: false, // グラフの縦横比を固定するか
        legend: {
          position: "top",
          display: false,
        },
        title: {
                position: "top",
                // padding: 20,
                display: true,
                fontSize: 18,
                fontColor: '#FF851C',
                text: '摂取目標 1000ml 以上'
        },
        tooltips: {
          enabled: true, //ここにfalseを指定
          titleFontSize: 25,
          bodyFontSize: 25,
        },
        layout: {
          padding: 5
        },
        scales: {
            xAxes: [
              {
                scaleLabel: {
                  display: true,
                },
                ticks: {
                  fontSize: 16,
                },
              },
            ],
            yAxes: [
              {
                ticks: {
                  beginAtZero: true,
                  min: 0, //最小値
                  max: 1500,
                  stepSize: 500,
                  fontSize: 20,
                },
              },
            ],
          },
      }
    },
    backHistory() {
      this.$router.push({name: 'History', params: {propsSelected: false}});
    },
  },
};
</script>

<style scoped>
.back-meal-vue {
  position: absolute;
  top: 1%;
  left: 3%;
  color: #fff;
  font-weight: 600;
}
.date {
  margin-top: 2%;
  margin-bottom: 5%;
  font-size: 1.7rem;
}
.date .day {
  margin: 0 15%;
  font-family: monospace;
}
.date .parenthesis {
  color: #00a0b9;
  font-weight: bold;
}
.water-weekly-bar {
  margin: 3%;
  height: 65vh;
  background-color: white;
  padding-top: 3%;
}
@media screen and (max-width:375px) and (max-height: 667px) { 
  .date {
  margin-top: 1%;
  margin-bottom: 2%;
  font-size: 1.5rem;
  }
}

</style>



// WEBPACK FOOTER //
// src/pages/WaterWeeklyBar.vue